import { Size } from '@ps/web-core-enums';
import { useScreenSize } from '@ps/web-shared-components';
import { Spring, animated } from '@react-spring/web';
import type { SpringConfig } from '@react-spring/web';
import React from 'react';

import styles from './SpringSlide.scss';

export interface Props {
  content: JSX.Element;
  onClick?(): void;
  offsetRadius: number;
  index: number;
  animationConfig: SpringConfig;
}

const sideIcon = {
  width: '60%'
};

const SpringSlide: React.FC<Props> = ({
  content,
  offsetRadius,
  index,
  animationConfig,
  onClick
}) => {
  const { greaterThan } = useScreenSize();
  const offsetFromCenter = index - offsetRadius;
  const totalPresentables = 2 * offsetRadius + 1;
  const distanceFactor = 1 - Math.abs(offsetFromCenter / (offsetRadius + 1));

  const translateXoffset = 50 * (Math.abs(offsetFromCenter) / (offsetRadius + 1));
  let translateX = -50;

  const adjustments = index !== 1 ? sideIcon : { width: 'auto' };

  if (offsetRadius !== 0) {
    if (index === 0) {
      translateX = 0;
    } else if (index === totalPresentables - 1) {
      translateX = -100;
    }
  }

  if (offsetFromCenter > 0) {
    translateX += translateXoffset;
  } else if (offsetFromCenter < 0) {
    translateX -= translateXoffset;
  }

  const featureScaleFactor = index === 1 ? 1 : distanceFactor;
  const frameLeft = offsetRadius === 0 ? 50 : 50 + (offsetFromCenter * 50) / offsetRadius;

  const enlargedCenter = index === 1 && !greaterThan(Size.XXSmall);
  const left = enlargedCenter ? 17.5 : frameLeft;
  translateX = enlargedCenter ? -11.5 : translateX;

  /* eslint-disable @typescript-eslint/no-explicit-any */
  return (
    <Spring
      to={{
        transform: `translateY(-50%) translateX(${translateX}%) scale(${featureScaleFactor})`,
        left: `${left}%`,
        opacity: distanceFactor * distanceFactor
      }}
      config={animationConfig}
    >
      {(style: any) => (
        <animated.div
          style={{ ...style, zIndex: Math.abs(Math.abs(offsetFromCenter) - 2), ...adjustments }}
          className={styles.container}
          onClick={onClick}
        >
          {content}
        </animated.div>
      )}
    </Spring>
  );
};

export default SpringSlide;
